import React from "react";

function Section4() {
  return (
    <div className="section4-container">
      <p>Popular Real Estate Searches</p>
      <a href="">Atlanta MLS</a> | <a href="">Chicago MLS</a> |
      <a href="">Dallas MLS</a> | <a href="">Los Angeles MLS</a> | <a href="">New York MLS</a> | <a href="">Orlando MLS</a> | <a href="">San Diego MLS</a> | <a href="">San Francisco MLS</a> |
      <a href="">Seattle MLS</a>
    </div>
  );
}

export default Section4;
